var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps-dom-highlight ps-border-solid ps-border-8 ps-absolute ps-opacity ps-pointer-events-none",style:(_vm.styles)})}
var staticRenderFns = []

export { render, staticRenderFns }